export enum CookieConsent {
  Necessary = 'necessary',
  Analytics = 'analytics'
}
